import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatStepper } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { AdmissionService } from 'src/app/services/admission.service';
import { InvoiceCashDeskService } from 'src/app/services/invoice-cash-desk/invoice-cash-desk.service';
import { InvoicePatientCashDeskService } from 'src/app/services/invoice-cash-desk/invoice-patient-cash-desk.service';
import { MenuService } from 'src/app/services/menu.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { AdmissionWizardService } from 'src/app/services/wizard/admission/admission.wizzard.service';
import { WizardStep, Wizard } from 'src/app/wizard/wizard.component';
import { AdmissionMedicalOrderComponent } from '../../admission/admission-medical-order/admission-medical-order.component';
import { AdmissionPatientComponent } from '../../admission/admission-patient/admission-patient.component';
import { AdmissionValorizationComponent } from '../../admission/admission-valorization/admission-valorization.component';

@Component({
  selector: 'app-admission-reception-wizard-control-component',
  templateUrl: './admission-reception-wizard-control.component.html',
  styleUrls: ['./admission-reception-wizard-control.component.css'],
  })
export class AdmissionReceptionWizardControlComponent implements OnInit {

  loadingAction: boolean;
  loading: boolean;
  steps: WizardStep[] = [];
  wizard: Wizard = new Wizard();
  stepIndex = 0;
  @ViewChild('admissionPatientComponent', {static: false}) admissionPatientComponent: AdmissionPatientComponent;
  @ViewChild('admissionValorizacionComponent', {static: false}) admissionValorizacionComponent: AdmissionValorizationComponent;
  @ViewChild('admissionMedicalOrderComponent', {static: false}) admissionMedicalOrderComponent: AdmissionMedicalOrderComponent;
  @ViewChild('stepper', {static: false}) stepper: MatStepper;
  medicalAppointmentId: number;

  constructor(private route: ActivatedRoute
    , private admissionWizardService: AdmissionWizardService
    , private admissionService: AdmissionService
    , private notificationToastService: NotificationToastService
    , private menuService: MenuService) {
    this.menuService.setMenuTitle('Recepción', '');
  }

  get admissionPracticeCompleted(): boolean { return this.admissionPatientComponent ?
    this.admissionPatientComponent.completed : false; }
  get admissionValorizationCompleted(): boolean { return this.admissionValorizacionComponent ?
    this.admissionValorizacionComponent.completed : false; }
  get admissionMedicalOrderCompleted(): boolean { return this.admissionMedicalOrderComponent ?
    this.admissionMedicalOrderComponent.completed : false; }

  async ngOnInit() {

    this.loading = true;
    this.route.params.subscribe(async (params) => {
      this.medicalAppointmentId = params['MedicalAppointmentId'];
      const combo = params['Combo'];

      const admission = !combo
        ? await this.admissionService.getNewAdmission(this.medicalAppointmentId)
        : await this.admissionService.getAdmissionInCombo(this.medicalAppointmentId);

      this.admissionWizardService.initialize(admission);
      this.loading = false;

      setTimeout(() => {
        this.steps = this.getSteps();
        this.wizard.configure(this.steps, this.stepper);
        this.wizard.initialize();
        // guardo aca porque cuando se toca el wizard desde los botonos de arriba no hace el submit
        this.stepper.selectionChange.subscribe(($event?: StepperSelectionEvent) => {
          if (this.steps[this.stepIndex].completed) {
            this.steps[this.stepIndex].save();
          }
          this.stepIndex = $event.selectedIndex;
          let index = -1;
          let complete = true;
          this.steps = this.getSteps();

          while (complete && index < this.stepIndex - 1) {
            index = index + 1;
            complete = this.steps[index].completed;
          }

          if (!complete) {
            this.stepIndex = index;
          } else {
            if (this.steps[this.stepIndex].isInit) {
              this.steps[this.stepIndex].activate();
            }
          }
        });
      }, 0);

    });
  }

  private getSteps() {
    const steps: WizardStep[] = [];
    // se tienen que agregar los pasos en el mismo orden que aparecen
    if (this.admissionPatientComponent) {
      steps.push(this.admissionPatientComponent);
    }
    if (this.admissionValorizacionComponent) {
      steps.push(this.admissionValorizacionComponent);
    }
    if (this.admissionMedicalOrderComponent) {
      steps.push(this.admissionMedicalOrderComponent);
    }
    return steps;
  }

  async finishAdmission() {
    try {
      if (this.admissionMedicalOrderComponent.completed) {
        this.loadingAction = true;
        await this.admissionWizardService.finish();
      } else if (this.admissionMedicalOrderComponent.validateOnLineRequired) {
        this.notificationToastService.error('No ha realizado el proceso de validación', 'Admisión');
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Admisión');
    } finally {
      this.loadingAction = false;
    }
  }

  cancel(): void {
    history.back();
  }
}
